import { FC } from "react";
import { Helmet } from "react-helmet-async";

export interface PageContactProps {
  className?: string;
}

const SectionContactUS: FC<PageContactProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageContact overflow-hidden ${className}`}
      data-nc-id="PageContact"
    >
      <div className=" max-w-7xl mx-auto lg:py-20">
        {/* Page Title */}

        <h3 className="mt-14 text-xl sm:text-2xl font-semibold text-slate-900">
          Contact Us
        </h3>

        {/* Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
          {/* Contact Info */}
          <div className="space-y-8">
            <div>
              <h3 className="mt-5 uppercase font-semibold text-sm tracking-wider">
                📍 Address
              </h3>
              <p className="mt-2 text-neutral-600 dark:text-neutral-400">
                111/A, VIJAY IND. ESTATE, NEAR, BHIKSHUK GRUH, ODHAV, AHMEDABAD,
                382415, Gujarat. <br />
                <a
                  href="https://maps.google.com/?q=DEVI+PLASTIC+Odhav+Ahmedabad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="
    inline-flex items-center gap-2 mt-3 px-5 py-2.5
    rounded-full font-medium text-white
    bg-gradient-to-r from-green-500 to-emerald-600
    shadow-lg shadow-green-500/30
    hover:from-green-600 hover:to-emerald-700
    hover:shadow-xl hover:shadow-green-500/40
    transition-all duration-300 ease-out
    active:scale-95
    focus:outline-none focus:ring-2 focus:ring-green-400
  "
                >
                  📍 View on Google Maps
                </a>
              </p>
            </div>

            <div>
              <h3 className="uppercase font-semibold text-sm tracking-wider">
                📞 Phone
              </h3>
              <p className="mt-2 text-neutral-600 dark:text-neutral-400">
                <a href="tel:9924823363" className="hover:underline">
                  +91 99248 23363
                </a>
              </p>
            </div>
          </div>

          {/* Google Map */}
          <div className="w-full h-[350px] rounded-2xl overflow-hidden shadow-lg">
            <iframe
              title="Devi Plastic Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117509.74431537521!2d72.54447476758688!3d23.01718026048262!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e874765367f3f%3A0x43387030b059f707!2sDEVI%20PLASTIC!5e0!3m2!1sen!2sin!4v1766912757466!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionContactUS;
